const acceptAudio = '.wav,.acc,.mpc,.ogg'
const acceptDocument = '.pdf,.doc,.csv,.xlsx,.xls,.docx,.ppt,.odt,.ods,.odp'
const acceptImage = '.jpeg,.jpg,.png'
const acceptVideo = '.mp4'

export const navigationLibrary = [
    {
        name: 'total', title: 'Minha biblioteca', href: '#', icon: 'hdd', current: false, to: { name: 'library.all'},
        children: [
            { name: 'total', title:'Audio', href: '#', icon: 'sliders-v', current: false, to:{ name: 'library.audio', params: {to:'audio'} }  },
            { name: 'total', title:'Documento', href: '#', icon: 'folder', current: false, to:{ name: 'library.document', params: {to:'document'} } },
            { name: 'total', title:'Imagem', href: '#', icon: 'image', current: false, to:{ name: 'library.image', params: {to:'image'} } },
            { name: 'total', title:'Video', href: '#', icon: 'play', current: false, to:{ name: 'library.video', params: {to:'video'} } },
        ],
    },
]

export const isSelectLibrary = {
    image: {
        icon: 'image',
        name: 'Imagem',
    },
    audio: {
        icon: 'sliders-v',
        name: 'Audio',
    },
    video: {
        icon: 'play',
        name: 'Video',
    },
    document: {
        icon: 'folder',
        name: 'Documento',
    },
}


export const dataPage = {
    all: {
        name: 'arquivo',
        title: 'Meus arquivos',
        notfound: 'Ainda não existem arquivos cadastrados.', 
        accept: `${acceptAudio},${acceptDocument},${acceptImage},${acceptVideo}`,
    },
    audio: {
        name: 'audio',
        title: 'Meus audios',
        icon: 'sliders-v',
        notfound: 'Ainda não existem audios cadastrados.',
        accept: acceptAudio,
    },
    document: {
        name: 'documento',
        title: 'Meus documentos',
        icon: 'folder',
        notfound: 'Ainda não existem documento cadastrado.',
        accept: acceptDocument,
    },
    image: {
        name: 'imagem',
        title: 'Minhas Imagens',
        icon: 'image',
        notfound: 'Ainda não existem imagens cadastradas.',
        accept: acceptImage,
    },
    video: {
        name: 'video',
        title: 'Meus videos',
        icon: 'play',
        notfound: 'Ainda não existem videos cadastrados.',
        accept: acceptVideo,
    },
}
export const dropdown = [
    {
        name: 'Editar',
        action: 'update',
        icon: 'list-ui-alt',
        class: ' hover:text-chat-primary',
    },
    {
        name: 'Copiar URL',
        action: 'copy',
        icon: 'copy',
        class: ' hover:text-chat-primary',
    },
    {
        name: 'Excluir',
        action: 'delete',
        icon: 'trash-alt',
        class: ' hover:text-red-500',
    },
]